function onGoogleMapsAPIReady() {
	window.googleMapsApiReady = true;

	if (Me.dispatch) {
		Me.dispatch.emit('googleMapsApiReady');
	}
}